import { z } from "zod";
/**
 * Card decks (ADR 0029): the table owner's choice, seen by everyone at the table. `classic` is
 * free and the default; `anime` and `obsidian` are Club decks, open to try (review 0015).
 */
export const deckIdSchema = z.enum(["classic", "anime", "obsidian"]);
export const DECK_IDS = deckIdSchema.options;
export const DEFAULT_DECK_ID = "classic";
//# sourceMappingURL=decks.js.map